export default __webpack_public_path__ + "static/media/EditorialExpand.2c03e88d.svg";